export default __webpack_public_path__ + "static/media/3.8dd7e3e7.jpg";